import React from "react";
import DefaultLogo from "../../../assets/avatar.png";

const FormHeader = ({
  component,
  logoPreview,
  nameLogo,
  titleName,
  isEditingHospital,
  isEditingTitle,
  onLogoClick,
  onNameLogoChange,
  onNameLogoBlur,
  onTitleNameChange,
  onTitleNameBlur,
  onEditNameLogo,
  onEditTitleName,
}) => {
  const formNumber = component.number || "NRO 002517";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        background: "#f7f7fa",
        color: "#222",
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        borderBottom: "1px solid #e0e0e0",
        minHeight: 80,
      }}
    >
      {/* Logo y hospital */}
      <div style={{ display: "flex", alignItems: "center", width: "33%" }}>
        <div onClick={onLogoClick} style={{ cursor: "pointer", marginRight: 16, position: "relative" }}>
          <img
            src={logoPreview ?? component.logo ?? DefaultLogo}
            alt="Logo Formulario"
            width={60}
            height={60}
            style={{ borderRadius: 8, objectFit: "cover", border: "1px solid #e0e0e0", background: "#fff" }}
          />
        </div>
        <div>
          {isEditingHospital ? (
            <input
              value={nameLogo}
              onChange={onNameLogoChange}
              onBlur={onNameLogoBlur}
              autoFocus
              className="border-b-light-border border-0 p-1"
              style={{
                fontWeight: 600,
                fontSize: 16,
                borderBottom: "1px solid #e0e0e0",
                outline: "none",
                minWidth: 120,
              }}
            />
          ) : (
            <p
              onClick={onEditNameLogo}
              className="cursor-pointer font-semibold"
              style={{ cursor: "pointer", fontWeight: 600, fontSize: 16, margin: 0 }}
            >
              {nameLogo}
            </p>
          )}
        </div>
      </div>
      {/* Título del formulario */}
      <div className="flex-grow mx-4 text-center" style={{ flexGrow: 1, margin: "0 32px", textAlign: "center" }}>
        {isEditingTitle ? (
          <input
            value={titleName}
            onChange={onTitleNameChange}
            onBlur={onTitleNameBlur}
            autoFocus
            className="border-b-light-border border-0 p-1 text-center"
            style={{
              fontWeight: 700,
              fontSize: 22,
              borderBottom: "1px solid #e0e0e0",
              outline: "none",
              textAlign: "center",
              minWidth: 120,
            }}
          />
        ) : (
          <h2
            className="text-xl font-semibold cursor-pointer"
            onClick={onEditTitleName}
            style={{ fontWeight: 700, fontSize: 22, margin: 0, cursor: "pointer" }}
          >
            {titleName}
          </h2>
        )}
      </div>
      {/* Número del formulario */}
      <div
        className="text-right w-1/3 text-red-600"
        style={{ textAlign: "right", width: "33%", color: "#d32f2f", fontWeight: 700, fontSize: 18 }}
      >
        <p style={{ margin: 0, cursor: "default" }}>{formNumber}</p>
      </div>
    </div>
  );
};

export default FormHeader;
